import { snackbar } from "@mobiscroll/react5";
import {
  getQueryWithParams,
  postMutation,
} from "src/components/ApolloConnection/ApolloProviderComponent";
import {
  ADD_LAB_TEST,
  ADD_LAB_TEST_TEMPLATE,
  ADD_PRESCRIPTION,
} from "src/components/graphql/GraphQLmutation";
import {
  GET_APPOINTMENT_LAB_TEST,
  GET_APPOINTMENT_PRESCIRPTION,
  LIST_LAB_TEST_TEMPLATES,
} from "src/components/graphql/GraphQLquery";

export async function addPrescription(data) {
  try {
    const response = await postMutation(ADD_PRESCRIPTION, data);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to add prescription");
    }

    const result = response?.data?.addPrescription;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to add prescription");
    }
    
    // Success case
    if (result?.data) {
      snackbar({
        message: result?.message || "Prescription added successfully.",
        color: "success",
      });
      return result.data;
    }
    throw new Error("No prescription data returned");
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at addPrescription:", e);
    return null;
  }
}

export async function getPrescription(data) {
  try {
    const response = await getQueryWithParams(GET_APPOINTMENT_PRESCIRPTION, data);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch prescription");
    }

    const result = response?.data?.getAppointment;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch prescription");
    }
    
    // Success case
    if (result?.data) {
      snackbar({
        message: result?.message || "Prescription fetched successfully.",
        color: "success",
      });
      return result.data;
    }
    throw new Error("No prescription data returned");
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at getPrescription:", e);
    return null;
  }
}

export async function addLabTest(data) {
  try {
    const response = await postMutation(ADD_LAB_TEST, data);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to add lab test");
    }

    const result = response?.data?.addTest;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to add lab test");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Lab test added successfully.",
      color: "success",
    });
    return result?.data || true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at addLabTest:", e);
    return null;
  }
}

export async function addDiagnosisLabTestTemplate(data) {
  try {
    const response = await postMutation(ADD_LAB_TEST_TEMPLATE, data);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to add lab test template");
    }

    const result = response?.data?.addDiagnosisLabTestTemplate;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to add lab test template");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Lab test template added successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at addDiagnosisLabTestTemplate:", e);
    return false;
  }
}

export async function listLabTests(data) {
  try {
    const response = await getQueryWithParams(GET_APPOINTMENT_LAB_TEST, data);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch lab tests");
    }

    const result = response?.data?.getAppointment;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch lab tests");
    }
    
    // Success case
    if (result?.data) {
      snackbar({
        message: result?.message || "Lab tests fetched successfully.",
        color: "success",
      });
      return result.data;
    }
    throw new Error("No lab test data returned");
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at listLabTests:", e);
    return null;
  }
}

export async function listLabTestTemplates(search = "", filters = "") {
  try {
    let clinicId = sessionStorage.getItem("clinic_id");
    const response = await getQueryWithParams(
      LIST_LAB_TEST_TEMPLATES,
      { search, clinicId, filters },
      true
    );
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch lab test templates");
    }

    const result = response?.data?.listDiagnosisLabTestTemplates;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch lab test templates");
    }
    
    // Success case - return data (no snackbar for template lists)
    return result?.data || [];
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at listLabTestTemplates:", e);
    return [];
  }
}
